/**
 * @generated SignedSource<<9ddee53639c2594f01f7978737ea48f3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useDynamicSplitButton_catchupLastViewedTimeReader$data = {
  readonly lastViewedTimeISO: string | null;
  readonly " $fragmentType": "useDynamicSplitButton_catchupLastViewedTimeReader";
};
export type useDynamicSplitButton_catchupLastViewedTimeReader$key = {
  readonly " $data"?: useDynamicSplitButton_catchupLastViewedTimeReader$data;
  readonly " $fragmentSpreads": FragmentRefs<"useDynamicSplitButton_catchupLastViewedTimeReader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "throwOnFieldError": true
  },
  "name": "useDynamicSplitButton_catchupLastViewedTimeReader",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "lastViewedTimeISO"
    }
  ],
  "type": "CatchupLastViewedTimeResponse"
};

(node as any).hash = "009f5cff1964484c1920fdf7471114c0";

export default node;
